import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { get } from "lodash";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import { RichText } from "prismic-reactjs";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
export default function TerpenesFeatureSlice(slice) {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("768"));

  const [terpenes, setTerpenes] = useState(false);
  const [selectedTerpene, setSelectedTerpene] = useState(false);

  const loading = useSelector((state) =>
    get(state, "prismic.terpenes_list.loading", true)
  );
  const data = useSelector((state) =>
    get(state, "prismic.terpenes_list.data", false)
  );

  useEffect(() => {
    dispatch({
      type: "PRISMIC_LOAD_REPEATABLE",
      key: "terpene",
      reduxKey: "terpenes_list",
    });
  }, [dispatch]);

  useEffect(() => {
    if (!loading && data) {
      const filteredTerpenes = data.filter(function (array_el) {
        return (
          slice.items.filter(function (anotherOne_el) {
            return anotherOne_el.terpene.id === array_el.id;
          }).length !== 0
        );
      });

      const sortList = [];

      slice.items.forEach((el) => {
        sortList.push(el.terpene.id);
      });

      const sortedObj = [...filteredTerpenes].sort((a, b) => {
        return sortList.indexOf(get(a, "id")) - sortList.indexOf(get(b, "id"));
      });

      setTerpenes(sortedObj);
      setSelectedTerpene(sortedObj[0]);
    }
  }, [data, loading]);

  const handleChange = (event) => {
    const selected = event.target.value || event.target.getAttribute("value");

    setSelectedTerpene(
      terpenes.find(
        (terpene) => get(terpene, "data.terpene_name[0].text") === selected
      )
    );
  };

  const currentTerpeneColor = get(selectedTerpene, "data.color");

  const terpeneStyle = {
    border: `3px solid ${currentTerpeneColor}`,
    color: currentTerpeneColor,
  };

  return (
    terpenes && (
      <div className="terpenes-feature-slice cool-margin">
        <div className="content">
          <div className="content-wrapper">
            <RichText render={slice.primary.content} />
          </div>
        </div>
        <div className="wrapper">
          {isMobile ? (
            <div className="filters">
              <FormControl>
                <TextField
                  id="select-terpene"
                  select
                  name="select-terpene"
                  value={get(selectedTerpene, "data.terpene_name[0].text")}
                  onChange={handleChange}
                  label="Select a Terpene"
                  variant="outlined"
                  style={{ width: "300px", marginBottom: "20px" }}
                  color="primary"
                >
                  {terpenes.map((terpene, i) => (
                    <MenuItem
                      key={i}
                      value={get(terpene, "data.terpene_name[0].text")}
                    >
                      {get(terpene, "data.terpene_name[0].text")}
                    </MenuItem>
                  ))}
                </TextField>
              </FormControl>
            </div>
          ) : (
            <div className="terpenes-list">
              {terpenes.map((terpene, i) => (
                <div
                  className={`terpene-button-container ${
                    get(selectedTerpene, "data.terpene_name[0].text") ===
                      get(terpene, "data.terpene_name[0].text") && "active"
                  }`}
                >
                  <h3
                    value={get(terpene, "data.terpene_name[0].text")}
                    onClick={handleChange}
                    key={i}
                    className="terpene-button"
                    style={
                      get(selectedTerpene, "data.terpene_name[0].text") ===
                      get(terpene, "data.terpene_name[0].text")
                        ? { color: currentTerpeneColor }
                        : {}
                    }
                  >
                    {get(terpene, "data.terpene_name[0].text")}
                  </h3>
                  {!isMobile && (
                    <div
                      className="line-indicator"
                      style={{ backgroundColor: currentTerpeneColor }}
                    />
                  )}
                </div>
              ))}
            </div>
          )}

          <div className="selected-terpene" style={terpeneStyle}>
            <img
              src={get(selectedTerpene, "data.icon.url")}
              className="terpene-icon"
              alt={get(selectedTerpene, "data.terpene_name[0].text")}
            />
            <div
              className="line"
              style={{ background: currentTerpeneColor }}
            ></div>
            <RichText render={selectedTerpene.data.content} />
          </div>
        </div>
      </div>
    )
  );
}
